import './js/dom/refs';
import './js/dom/checkForLoginState';
import './js/dom/modalLogIn';
import './js/dom/modalSignUp';
import './js/api/fetchAPI';

import './js/dom/footerModal';
import './js/dom/movieModal';

import './js/dom/renderMovieModal';
import './js/dom/renderMovies';
import './js/dom/trailer';
import './js/dom/watchedLS';
import './js/dom/queueLS';
import './js/dom/trailer';

import './js/utils/scrollToTop';
import './js/utils/spinner';
import './js/utils/themes';
